module.exports = __webpack_public_path__ + "img/jpg.645c16cd.png";